import { requestJson } from "./apiClient";

const base = (clientViewId) => `/api/admin/client-views/${encodeURIComponent(clientViewId)}/sponsorship`;

export function listSponsorshipInventorySlots(clientViewId) {
  return requestJson(`${base(clientViewId)}/inventory`);
}

export function createSponsorshipInventorySlot(clientViewId, payload) {
  return requestJson(`${base(clientViewId)}/inventory`, { method: "POST", body: payload });
}

export function updateSponsorshipInventorySlot(clientViewId, slotId, payload) {
  return requestJson(`${base(clientViewId)}/inventory/${encodeURIComponent(slotId)}`, {
    method: "PUT",
    body: payload,
  });
}

export function patchSponsorshipInventorySlotStatus(clientViewId, slotId, isActive) {
  return requestJson(`${base(clientViewId)}/inventory/${encodeURIComponent(slotId)}/status`, {
    method: "PATCH",
    body: { isActive },
  });
}

export function listSponsorshipPlacements(clientViewId, query = {}) {
  const params = new URLSearchParams(query).toString();
  const suffix = params ? `?${params}` : "";
  return requestJson(`${base(clientViewId)}/placements${suffix}`);
}

export function createSponsorshipPlacement(clientViewId, payload) {
  return requestJson(`${base(clientViewId)}/placements`, { method: "POST", body: payload });
}

export function updateSponsorshipPlacement(clientViewId, placementId, payload) {
  return requestJson(`${base(clientViewId)}/placements/${encodeURIComponent(placementId)}`, {
    method: "PUT",
    body: payload,
  });
}

export function patchSponsorshipPlacementStatus(clientViewId, placementId, status) {
  return requestJson(`${base(clientViewId)}/placements/${encodeURIComponent(placementId)}/status`, {
    method: "PATCH",
    body: { status },
  });
}

export function previewSponsorshipPlacement(clientViewId, placementId) {
  return requestJson(`${base(clientViewId)}/placements/${encodeURIComponent(placementId)}/preview`, {
    method: "POST",
  });
}

export function listSponsorshipCampaigns(clientViewId) {
  return requestJson(`${base(clientViewId)}/campaigns`);
}

export function createSponsorshipCampaign(clientViewId, payload) {
  return requestJson(`${base(clientViewId)}/campaigns`, { method: "POST", body: payload });
}

export function updateSponsorshipCampaign(clientViewId, campaignId, payload) {
  return requestJson(`${base(clientViewId)}/campaigns/${encodeURIComponent(campaignId)}`, {
    method: "PUT",
    body: payload,
  });
}
